import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../data/mock';
import { track } from '../lib/analytics';

/**
 * Bloque de preguntas frecuentes. Cubre las objeciones que hoy solo se
 * resolvian escribiendo por WhatsApp: pedido minimo, tiempos, factura,
 * formas de pago y cobertura de entrega.
 *
 * `emitSchema` marca la pagina canonica del FAQPage. Solo debe activarse en
 * UNA pagina del sitio para no duplicar el mismo bloque de datos.
 */
const Faq = ({ emitSchema = false, title = 'Preguntas frecuentes', subtitle, className = '' }) => (
  <>
    {emitSchema && (
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: { '@type': 'Answer', text: faq.answer },
            })),
          })}
        </script>
      </Helmet>
    )}

    <div className={className}>
      <h2 className="text-3xl sm:text-4xl font-heading font-bold text-wood-900 leading-tight mb-3">
        {title}
      </h2>
      {subtitle && <p className="text-wood-600 text-lg mb-8">{subtitle}</p>}

      <Accordion
        type="single"
        collapsible
        className="w-full"
        onValueChange={(value) => value && track('faq_opened', { question: value })}
      >
        {faqs.map((faq) => (
          <AccordionItem key={faq.id} value={faq.question} className="border-wood-200/60">
            <AccordionTrigger className="text-base sm:text-lg font-semibold text-wood-900 hover:no-underline py-5">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-wood-600 leading-relaxed text-base pb-5">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </>
);

export default Faq;
